import React from 'react';
import { Typography } from '@material-ui/core';
import { ChartLabelProps } from '../types';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  smapleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  colorSample: {
    height: theme.spacing(1.25),
    width: theme.spacing(1.25),
    marginRight: theme.spacing(1),
  },
}));

export default function ChartLabel({ name, color }: ChartLabelProps) {
  const classes = useStyles();
  return (
    <div className={classes.smapleContainer}>
      <div className={classes.colorSample} style={{ backgroundColor: color }} />
      <Typography variant="subtitle1">{name}</Typography>
    </div>
  );
}
